import React from 'react';

export const SecurityCard = ({ icon, title, description }) => (
  <div className="p-6 backdrop-blur-xl overflow-hidden border-b md:border-r md:border-b-0 border-border/50 last:border-0">
    <div className="text-highlight p-2 rounded-md inline-block bg-highlight/10">{icon}</div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-muted-foreground">{description}</p>
  </div>
);
